import { Card, Text } from '@mantine/core'

import { useQueryGetInquiryById } from '@flecto/core/saas'
import { useTranslation } from '@flecto/translations'

export type CardInquiryNotesProps = {
  inquiryId: number
}

export function CardInquiryNotes({ inquiryId }: CardInquiryNotesProps) {
  const { data } = useQueryGetInquiryById({ inquiryId })
  const { t } = useTranslation('saas', { keyPrefix: 'inquiries' })

  const inquiry = data?.inquiry

  const hasMessage = Boolean(inquiry?.renter_message)

  const message = hasMessage ? inquiry?.renter_message : t('notes.placeholder')

  return (
    <Card>
      <Text fw={500} mb='sm'>
        {t('notes.title')}
      </Text>
      <Text c={!hasMessage ? 'dimmed' : undefined}>{message}</Text>
    </Card>
  )
}
